import { heroBoutique } from '@/assets/images';

export default function Hero() {
  return (
    <section id="inicio" className="relative h-screen min-h-[720px] w-full overflow-hidden bg-ink-900">
      <div className="absolute inset-0">
        <img
          src={heroBoutique}
          alt="Interior de la boutique SANO Moda en Llíria, Valencia · percheros, mesas de punto y complementos"
          title="Interior de la tienda SANO Moda · Llíria, Valencia"
          className="w-full h-full object-cover object-center contrast-[1.06] saturate-[1.05]"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/15 to-black/55"></div>
      </div>

      <div className="pointer-events-none absolute inset-3 md:inset-5 z-10 border border-cream-50/30"></div>

      <div className="relative z-10 h-full w-full flex flex-col items-center justify-center px-6">
        <div className="w-full max-w-[760px] px-8 md:px-14 py-12 md:py-16 text-center">
          <p className="fade-up text-cream-50 text-[11px] tracking-widest-xl mb-8 drop-shadow-[0_2px_14px_rgba(0,0,0,0.9)]">
            LLÍRIA · VALENCIA
          </p>
          <h1 className="fade-up flex justify-center">
            <span
              role="img"
              aria-label="SANO Moda · Llíria, Valencia"
              className="logo-wordmark logo-white block w-[240px] md:w-[420px] lg:w-[480px] h-[72px] md:h-[132px] lg:h-[152px]"
            />
          </h1>
          <div className="fade-up-delay mt-6 flex items-center justify-center gap-4 text-cream-50 text-[11px] md:text-xs tracking-widest drop-shadow-[0_2px_14px_rgba(0,0,0,0.9)]">
            <span>MODA</span>
            <span className="w-1 h-1 bg-cream-50/70"></span>
            <span>ESTILO</span>
            <span className="w-1 h-1 bg-cream-50/70"></span>
            <span>TENDENCIA</span>
          </div>
          <p className="fade-up-delay mt-9 font-display italic text-cream-50 text-xl md:text-2xl leading-snug drop-shadow-[0_2px_16px_rgba(0,0,0,0.9)]">
            Más de 38 años a tu lado
          </p>
          <p className="fade-up-delay mt-4 mx-auto max-w-[460px] text-cream-50/90 text-sm md:text-[15px] leading-relaxed tracking-wide drop-shadow-[0_2px_14px_rgba(0,0,0,0.9)]">
            Moda seleccionada temporada tras temporada en el corazón de Llíria.
          </p>
          <div className="fade-up-delay mt-10 flex justify-center">
            <a
              href="#mujer"
              className="inline-flex items-center gap-3 px-9 py-4 border border-cream-50 text-cream-50 text-[11px] tracking-widest bg-black/25 hover:bg-cream-50 hover:text-ink-900 transition-all duration-500 cursor-pointer whitespace-nowrap drop-shadow-[0_2px_10px_rgba(0,0,0,0.7)]"
            >
              DESCUBRE NUESTRA COLECCIÓN
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-9 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-3 text-cream-50">
        <span className="text-[10px] tracking-widest">SCROLL</span>
        <div className="w-1 h-9 bg-cream-50/60"></div>
      </div>
    </section>
  );
}